import type { Release } from "api/dashboardBackend";
import { getDisplayVersion } from "components/dashboard/release-card/ReleaseCardTitle";

export interface SemVer {
  major: number;
  minor: number;
  patch?: number;
  build?: number;
  suffix?: string;
}

export const buildVersionString = (release: Release): string => {
  const displayVersion = getDisplayVersion(release.majorMinor, release.patch);
  return `${displayVersion.majorMinor}.${displayVersion.patch}${
    release.build ? `.${release.build}` : ""
  }${release.versionSuffix}`;
};

export const semVerString = (semVer: SemVer): string =>
  [semVer.major, semVer.minor, semVer.patch, semVer.build]
    .filter(part => part !== undefined && part !== null)
    .join(".");
